import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
// import { objAny } from "@/common/common-interface";
let PiCardBox = class PiCardBox extends Vue {
};
__decorate([
    Prop({ default: "" })
], PiCardBox.prototype, "title", void 0);
__decorate([
    Prop({ default: "" })
], PiCardBox.prototype, "size", void 0);
__decorate([
    Prop({ default: false })
], PiCardBox.prototype, "isCard", void 0);
__decorate([
    Prop({ default: true })
], PiCardBox.prototype, "titleIconShow", void 0);
__decorate([
    Prop({ default: "line" })
], PiCardBox.prototype, "titleIcon", void 0);
PiCardBox = __decorate([
    Component({
        components: {},
    })
], PiCardBox);
export default PiCardBox;
